export default "__VITE_ASSET__1aea7b1b__"